module.exports = __webpack_public_path__ + "static/media/empty-star.8c748241.svg";